module.exports = __webpack_public_path__ + "static/img/banner2.4871d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ShopSelfPrinting/banner2.png
// module id = L0T2
// module chunks = 10